/*** IMPORTS FROM imports-loader ***/
var define = false;

import { Observable } from "./Observable.js";
import { canUseSymbol } from "../common/canUse.js";
export function fixObservableSubclass(subclass) {
    function set(key) {
        Object.defineProperty(subclass, key, { value: Observable });
    }
    if (canUseSymbol && Symbol.species) {
        set(Symbol.species);
    }
    set("@@species");
    return subclass;
}
//# sourceMappingURL=subclassing.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/@apollo/client/utilities/observables/subclassing.js
// module id = 739
// module chunks = 0